import React from "react";
import { Typography } from "@mui/material";

const EmailPhoneCell = ({ row }) => {
  return (
    <>
      {row?.respondent_email || row?.respondent_phone ? (
        <>
          {row?.respondent_email && <Typography fontSize="15px">{row.respondent_email}</Typography>}
          {row?.respondent_phone && (
            <Typography fontSize="15px">{row.respondent_phone}</Typography>
          )}
        </>
      ) : (
        <Typography fontSize="15px">--</Typography>
      )}
    </>
  );
};

export default EmailPhoneCell;
